import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { enumSocialMediaPostType } from "../../../../enums";
import { ISocialMediaPostDisplaySpecs } from "../ISocialMediaPostDisplaySpecs";

/**
 * @function deriveDisplaySpecsForTruthSocial Derives the specs needed to display a TruthSocial Social Media Post from a raw reference
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export function deriveDisplaySpecsForTruthSocial(socialMediaPostRawReference: string): ISocialMediaPostDisplaySpecs {

  // set default displaySpecs values for TruthSocial
  let displaySpecs: ISocialMediaPostDisplaySpecs = { socialMediaPostType: enumSocialMediaPostType.Undefined, url: '', width: '600px', height: '350px' };;

  // execute the regular expression against the url to determine if the socialMediaPostRawReference represents a standard TruthSocial Post EmbedUrl
  const matchEmbedUrl: RegExpExecArray | null = RegularExpressions.TruthSocialPostEmbedUrl.exec(socialMediaPostRawReference);

  // if a match was made for a simple embed url...
  if (matchEmbedUrl && matchEmbedUrl.groups && matchEmbedUrl.groups.embedUrl) {
    // set the specs for displaying the post
    displaySpecs = { socialMediaPostType: enumSocialMediaPostType.TruthSocial, url: matchEmbedUrl.groups.embedUrl, width: '600px', height: '350px' };
  } else {
    // execute the regular expression against the url to determine if the url represents a Truth Social IFrame with full specs
    const matchIFrameWithFullSpecs: RegExpExecArray | null = RegularExpressions.TruthSocialPostIFrameWithFullSpecs.exec(socialMediaPostRawReference);

    // if a match was made for an <iframe>...
    if (matchIFrameWithFullSpecs && matchIFrameWithFullSpecs.groups) {
      // set the Social Media Post Type
      displaySpecs.socialMediaPostType = enumSocialMediaPostType.TruthSocial;

      // if the embedUrl is found...
      if (matchIFrameWithFullSpecs.groups.embedUrl) {
        displaySpecs.url = matchIFrameWithFullSpecs.groups.embedUrl;
      }

      // if the 'width' parameter was found, ... 
      if (matchIFrameWithFullSpecs.groups.width) {
        // convert to a number and set value into the displaySpecs.width variable
        displaySpecs.width = parseInt(matchIFrameWithFullSpecs.groups.width);
      }
    }
  }

  return displaySpecs;
}
